export enum YandexAdvertisingSliceId {
  Webcam = 1,
  WebcamTest = 1000,
  WebcamGuides = 1001,
  WebcamStore = 1002,

  Mic = 2,
  MicTest = 2000,
  MicGuides = 2001,
  MicStore = 2002,

  Headphones = 3,
  HeadphonesTest = 3000,
  HeadphonesTestMusic = 3001,
  HeadphonesTestGenerator = 3002,
  HeadphonesTestFly = 3003,
  HeadphonesGuides = 3004,

  Internet = 4,
  Docs = 5,
}
